import React, { useState, useEffect, useRef } from "react";
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import './InspectionAllocationReport.css';
import { jsPDF } from "jspdf";  // Import jsPDF
import "jspdf-autotable";
import pds from './pds.PNG';
import Select from 'react-select'; // Import react-select
import { format, parse, set } from 'date-fns';
import ExcelJS from 'exceljs';

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};
const InspectionAllocationReport = () => {
    const [data, setData] = useState([]);
    const [assignedById, setAssignedById] = useState(''); // State for Assigned By
    const [assignedToId, setAssignedToId] = useState(''); // State for Assigned To
    const [totalFps, setTotalFps] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState(null); // Selected district for drill-down
    const [subdivisionData, setSubdivisionData] = useState([]);
    const [selectedSubdivision, setSelectedSubdivision] = useState(null);
    const [detailedSubdivisionData, setDetailedSubdivisionData] = useState([]);
    const [selectedBlock, setSelectedBlock] = useState(null);
    const [blockData, setBlockData] = useState([]);
    const [panchayatData, setPanchayatData] = useState([]);

    const [selectedPanchayat, setSelectedPanchayat] = useState(null);
    const [afterpanchayatData, setAfterPanchayatData] = useState([]);
    const [isReportGenerated, setIsReportGenerated] = useState(false); // Track report generation status
    const [tableData, setTableData] = useState([]); // Store table data
    const [usernameTo, setUserNameTo] = useState('');
    const sortData = (data) => {
        return data.sort((a, b) => {
            const fairPriceShopDetailsA = a.fairPriceShopDetails || {};
            const fairPriceShopDetailsB = b.fairPriceShopDetails || {};

            const districtA = fairPriceShopDetailsA.district || '';
            const districtB = fairPriceShopDetailsB.district || '';
            const subDivisionA = fairPriceShopDetailsA.subDivision || '';
            const subDivisionB = fairPriceShopDetailsB.subDivision || '';
            const blockA = fairPriceShopDetailsA.block || '';
            const blockB = fairPriceShopDetailsB.block || '';
            const panchayatA = (fairPriceShopDetailsA.panchayat || '').trim();
            const panchayatB = (fairPriceShopDetailsB.panchayat || '').trim();

            // Sorting order: first district, then sub-division, then block, and finally panchayat
            if (districtA < districtB) return -1;
            if (districtA > districtB) return 1;
            if (subDivisionA < subDivisionB) return -1;
            if (subDivisionA > subDivisionB) return 1;
            if (blockA < blockB) return -1;
            if (blockA > blockB) return 1;
            if (panchayatA < panchayatB) return -1;
            if (panchayatA > panchayatB) return 1;
            return 0;
        });
    };


    const [dataAvailable, setDataAvailable] = useState(false);  // New state for checking if data is available
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 25;
    // Sorted data before rendering
    const sortedData = sortData(data);
    // Calculate the index range for the current page
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    const currentRecords = sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
    // Ensure sortedData is properly passed and initialized
    useEffect(() => {
        if (sortedData.length > 0) {
            setDataAvailable(true);  // Set dataAvailable to true if data is available
        }
    }, [sortedData]);
    const [districtUid, setDistrictUid] = useState(''); // Store districtUid for reports
    const [subDivisionUid, setSubDivisionUid] = useState(''); // Store subdistrictUid for reports
    const [blockUid, setBlockUid] = useState(' ');
    const [panchayatUid, setPanchayatUid] = useState(' ');
    const [showTable, setShowTable] = useState(false);
    //  const [reportData, setReportData] = useState([]);
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);
    // const [fpsId, setFpsId] = useState("");  // Ensure this is defined at the top of your component
    const [inspectionOfficerId, setInspectionOfficerId] = useState(null);
    const [inspectionOfficers, setInspectionOfficers] = useState([]);
    const [designationName, setDesignationName] = useState('');
    const [officerDesignation, setOfficerDesignation] = useState('');
    const [username, setUserName] = useState('');
    const [poimsUserId, setId] = useState('');
    const [id, setUserId] = useState('');

    const [error, setError] = useState(null);  // Define setError here
    const [isLoading, setIsLoading] = useState(false);

    //const [showDownloadPdf, setShowDownloadPdf] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [stockData, setStockData] = useState([]);


    const reportRef = useRef(null);  // Reference to the report HTML
    const [isOpen, setIsOpen] = useState(false); // To control dropdown open/close
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(currentYear, 0, 1); // January 1st of current year
    const nextPage = () => {
        if (currentPage < Math.ceil(sortedData.length / recordsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };
    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const handleStartDateChange = (date) => {
        setStartDate(date);       // Set the selected start date
        setEndDate('');           // Clear the end date when start date changes
        setShowCalendar(false);   // Hide the calendar after selection
        setShowTable(false);
    };
    const handleEndDateIconClick = () => {
        // Only show the calendar for endDate if startDate is selected
        if (startDate) {
            setShowEndCalendar(true);
        }
    };
    const handleEndDateChange = (date) => {
        setEndDate(date);
        setShowEndCalendar(false);
        setShowTable(false);
    };
    const formatNumber = (number) => {
        return new Intl.NumberFormat('en-IN').format(number); // 'en-IN' for Indian number formatting (commas at appropriate positions)
    };
    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;  // Define the base URL
    useEffect(() => {
        // console.log('Token:', token);  // Check if token is set
        if (token) {
            axios.get(`${baseUrl}/districts?pagination[pageSize]=50`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {
                        setDistricts(response.data.data);
                        const updatedDistricts = [
                            { district: 'All', districtName: 'All Districts', districtUid: null }, // 'All' option
                            ...response.data.data
                        ];
                        setDistricts(updatedDistricts); // Set the updated districts with 'All'
                    } else {
                        setError("Invalid response format");
                    }
                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);
    const fetchSubDivisions = async (districtId) => {
        if (districtId) {
            try {
                const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setSubDivisions(response.data.data || []);
                //  console.log('Sub-Divisions:', response.data.data);  // Log response data for debugging
            } catch (error) {
                // Enhanced error logging
                if (error.response) {
                    console.error('Error Response:', error.response);
                    setError(`Error fetching sub-divisions: ${error.response.status} ${error.response.statusText}`);
                } else if (error.request) {
                    console.error('Error Request:', error.request);
                    setError('No response from the server');
                } else {
                    console.error('Error Message:', error.message);
                    setError(`Error: ${error.message}`);
                }
            }
        } else {
            setSubDivisions([]);
        }
    };

    const fetchBlocks = async (subDivisionId) => {
        if (subDivisionId) {
            try {
                const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=50`, {
                    headers: {
                        Authorization: `Bearer ${token}`,  // Include the Authorization token if needed
                    }
                });
                setBlocks(response.data.data || []);  // Ensure the data exists and is in the expected format
                //console.log('Blocks:', response.data.data);  // Log the response data for debugging
            } catch (error) {
                console.error('Error fetching blocks:', error);  // Improved error logging
                setError("Error fetching blocks");
            }
        } else {
            // If no sub-division is selected, reset the blocks state
            setBlocks([]);
        }
    };

    const fetchPanchayats = async (blockId) => {
        if (blockId) {
            try {
                const response = await axios.get(`${baseUrl}/panchayats?filters[block][id][$eq]=${blockId}&pagination[pageSize]=100`, {
                    headers: {
                        Authorization: `Bearer ${token}`,  // Make sure token is included if needed
                    }
                });
                setPanchayats(response.data.data || []);  // Update state with panchayats data
                // console.log('Panchayats:', response.data.data);  // Debugging the fetched data
            } catch (error) {
                console.error('Error fetching panchayats:', error);
                setError("Error fetching panchayats");
            }
        } else {
            setPanchayats([]);  // If no block selected, reset panchayats
        }
    };

    const fetchInspectionOfficers = async () => {
        try {
            //console.log('Fetching inspection officers...');
            //console.log('District UID:', districtUid);  // Check if districtUid is set correctly
            if (!districtUid) {
                setError("District UID is required.");
                return;
            }
            const apiUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api/user-posting/get-all`;
            const requestData = {};
            if (districtUid) {
                requestData.district = districtUid;
            }
            if (subDivisionUid) {
                requestData.subDivision = subDivisionUid;
            }
            if (blockUid) {
                requestData.block = blockUid;
            }

            // console.log('Request Data:', requestData);  // Debugging the request body
            const response = await axios.post(apiUrl, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // console.log('Response:', response);  // Log the full response to check for data or errors
            setInspectionOfficers(response.data);  // Set the data
            setOfficerDesignation(response.data);

        } catch (error) {
            console.error('Error:', error);  // Log full error
            if (error.response) {
                console.error('Response Error:', error.response.data);  // Log the response error
                setError(`Error: ${error.response.status} - ${error.response.data.message}`);
            } else {
                setError("An error occurred while fetching inspection officers.");
            }
        }
    };
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (districtUid) {
                fetchInspectionOfficers(); // Only call once after debounce delay
            }
        }, 100); // Delay in milliseconds
        return () => clearTimeout(timeoutId); // Cleanup timeout on effect cleanup or when dependencies change
    }, [districtUid, subDivisionUid, blockUid]); // Trigger when any of these state variables change


    const handleInspectionOfficerChangeBy = (selectedOption) => {
        const selectedIdBy = selectedOption ? selectedOption.value : '';
        const selectedOfficer = inspectionOfficers.find((officer) => officer.id === selectedIdBy);
        const selectedOfficerUsername = selectedOption ? selectedOption.username : '';

        setAssignedById(selectedIdBy); // Update the Assigned By state
        setUserName(selectedOfficerUsername); // Optional, depending on use case
        // console.log("By Selected", selectedIdBy);
        // console.log("By Selected username", selectedOfficerUsername);
        setAssignedToId('');
    };

    const handleInspectionOfficerChangeTo = (selectedOption) => {
        const selectedIdTo = selectedOption ? selectedOption.value : '';
        const selectedOfficer = inspectionOfficers.find((officer) => officer.id === selectedIdTo);
        const selectedOfficerUsername = selectedOption ? selectedOption.username : '';

        setAssignedToId(selectedIdTo); // Update the Assigned To state
        // console.log("To Selected", selectedIdTo);
        // setUserName(selectedOfficerUsername); // Optional, depending on use case
        setUserNameTo(selectedOfficerUsername); // Optional, depending on use case 360
        // console.log("To Selected username", selectedOfficerUsername);
    };

    const handleDistrictChange = (selectedOption) => {
        const selectedDistrictId = selectedOption ? selectedOption.value : '';  // districtId for filtering
        const selectedDistrictUid = selectedOption ? selectedOption.districtUid : '';  // districtUid for reports

        //console.log('Selected District ID (for filtering):', selectedDistrictId);  // for filtering
        //console.log('Selected District UID (for report generation):', selectedDistrictUid);  // for report generation
        setDistrictId(selectedDistrictId);  // For filtering
        setDistrictUid(selectedDistrictUid);  // For report generation
        setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setSubDivisionId('');  // Reset sub-division
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setPanchayats([])
        setBlocks([])
        setInspectionOfficerId(''); // Clear the inspection officer ID
        setId(''); // Clear poimsUserId
        //   setInspectionDates([])
        //  setInspectionDate('')
        setShowTable(false);
        setInspectionOfficerId('');
        fetchSubDivisions(selectedDistrictId);  // Fetch subdivisions based on the selected district
        fetchInspectionOfficers(selectedDistrictId);
        setDesignationName('');
        setOfficerDesignation('');
        setData([]);
        setAssignedById('');
        setAssignedToId('');

    };

    const handleSubDivisionChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectdSubDivisionUid = selectedOption ? selectedOption.subDivisionUid : "";
        const selectdSubDivisionName = selectedOption ? selectedOption.label : "";
        // console.log('Selected Subdivision:', selectedId);
        // Reset everything except block
        setSubDivisionUid(selectdSubDivisionUid);
        //  setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setSubDivisionId(selectedId);
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        //  setFpsId('');  // Reset FPS ID
        //setFPShops([]);  // Clear FPS shops 
        setPanchayats([]);  //it is not actved panchayats without selecting
        setBlocks([]); //it is not actved block  without selecting
        //   setInspectionDates([])
        //   setInspectionDate('')
        setInspectionOfficerId(''); // Clear the inspection officer ID
        setId(''); // Clear poimsUserId
        // setInspectionOfficerId('');
        setShowTable(false);
        fetchBlocks(selectedId);  // Fetch blocks based on the selected subdivision
        fetchInspectionOfficers(selectedId);
        setDesignationName('');
        setOfficerDesignation('');
        setData([]);

        setAssignedById('');
        setAssignedToId('');

    };

    const handleBlockChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedBlockUid = selectedOption ? selectedOption.blockUid : '';
        // console.log('Selected Block:', selectedId);
        //console.log('Selected BlockUid:', selectedBlockUid);
        // Reset everything except panchayat
        setBlockId(selectedId);
        setBlockUid(selectedBlockUid);
        setPanchayatId('');  // Reset panchayat
        //  setFpsId('');  // Reset FPS ID
        //setFPShops([]);  // Clear FPS shops without selecting
        setPanchayats([]);  //it is not actved panchayats  without selecting
        // setInspectionDates([])
        //  setInspectionDate('')
        setInspectionOfficerId('');
        setPanchayatUid('');
        setShowTable(false);
        setInspectionOfficerId(''); // Clear the inspection officer ID
        setId(''); // Clear poimsUserId
        fetchPanchayats(selectedId);
        fetchInspectionOfficers(selectedId);
        setDesignationName('');
        setOfficerDesignation('');
        setData([]);
        setAssignedById('');
        setAssignedToId('');

    };

    const handlePanchayatChange = (selectedOption) => {

        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedpanchayatUid = selectedOption ? selectedOption.panchayatUid : '';
        // console.log('Selected Panchayat:', selectedId);
        // console.log("selected panUid", selectedpanchayatUid);
        setPanchayatUid(selectedpanchayatUid);
        // Reset only FPS ID, as panchayat is selected
        setPanchayatId(selectedId);
        setId('');
        setInspectionOfficerId('');
        //  setFpsId('');  // Reset FPS ID
        // setFPShops([]);  // Clear FPS shops not accepting fps without selecting
        // setInspectionDates([])
        // setInspectionDate('')
        //   fetchFPShops(selectedId);  // Fetch FPS shops based on the selected panchayat
        setShowTable(false);
        setDesignationName('');
        setOfficerDesignation('');
        setData([]);
        setAssignedById('');
        setAssignedToId('');

    };

    // Function to clear all data (reset state)
    const handleClear = () => {
        setCurrentPage(1);
        setInspectionOfficerId('');
        setDistrictUid(null);
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setPanchayatId('');
        setStartDate('');
        setEndDate('');
        setShowDownloadButton(false);
        setShowTable(false);
        setDesignationName('');
        setOfficerDesignation('');
        setData([]); // Clears table data
        setTableData([]); // Clears table data
        setIsReportGenerated(false);
        setSelectedDistrict(null);
        setSelectedSubdivision(null);
        setSelectedBlock(null);
        setSelectedPanchayat(null);
        setAfterPanchayatData(false);
        setAssignedById('');
        setAssignedToId('');
        setUserName('');
        setUserNameTo('');
    };

    // Initialize columns and tableData
    let columns = [];
    // columns.push({ Header: 'S.No', accessor: 'sno' });
    columns.push({ Header: 'District', accessor: 'districtName' });

    if (subDivisionId) {
        columns.push({ Header: 'Sub Division', accessor: 'subDivisionName' });
    }

    if (blockId) {
        columns.push({ Header: 'Block', accessor: 'blockName' });
    }

    if (panchayatId) {
        columns.push({ Header: 'Panchayat', accessor: 'panchayatName' });
        // columns.push({ Header: 'Assigned By', accessor: 'assignedBy' });
        // columns.push({ Header: 'Assigned To', accessor: 'assignedTo' });
        // columns.push({ Header: 'No. of FPS Allocated', accessor: 'fpsCount' });
        // columns.push({ Header: 'Date of Inspection', accessor: 'inspectionDate' });  // Uncomment if needed
    }
    // These columns will only be added when panchayatId is not present
    columns.push({ Header: 'Total No. of FPS', accessor: 'totalFps' });
    columns.push({ Header: 'No. of FPS Allocated', accessor: 'fpsCount' });
    columns.push({ Header: '% Allocation', accessor: 'percentageAllocation' });


    const formatDateTable = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = String(d.getFullYear()); // Get the full year
        return `${day}-${month}-${year}`;
    };


    useEffect(() => {
        if (assignedById && assignedToId) {
            // If both assignedById and assignedToId are the same
            if (assignedById === assignedToId) {
                alert("Assigned By and Assigned To cannot be the same.");
                // Reset the Assigned To value
                setAssignedToId('');
                setUserNameTo(''); // Optionally clear the assignedToId's username
            }
        }
    }, [assignedById, assignedToId]);

    // Handle API response and populate tableData
    const handleGenerateReport = (e) => {
        //e.preventDefault();
        setIsLoading(true);
        setStockData([]);
        setIsReportGenerated(true);
        // setTableData(fetchedData);
        // Prepare the request data
        const requestData = {};

        if (startDate) {
            requestData.from = formatDate(startDate);
        }
        if (endDate) {
            requestData.to = formatDate(endDate);
        }

        // Add filters based on selection
        if (districtUid) {
            requestData.district = districtUid;
        } else {
            requestData.district = "All";
        }
        if (subDivisionUid) {
            requestData.subDivision = subDivisionUid;
        }
        if (blockUid && blockUid.trim() !== "") {
            requestData.block = blockUid;
        }
        if (panchayatUid && panchayatUid.trim() !== "") {
            requestData.panchayat = panchayatUid;
        }
        // if (poimsUserId) {
        //     requestData.poimsUserId = poimsUserId;
        // }
        if (username) {
            requestData.assignedBy = username; // Add the Assigned By ID
            //  console.log("assignedBy", requestData.assignedBy);
        }
        // if (username) {
        //     requestData.assignedTo = username; // Add the Assigned To ID
        // }
        if (usernameTo) {
            requestData.assignedTo = usernameTo; // Add the Assigned To ID
        }

        //  console.log("payload", requestData);

        // API call based on hierarchy of selections
        let apiUrl = '';

        if (districtUid && !subDivisionUid && !blockUid && !panchayatUid) {
            apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/inspectionScheduling/getAllocatedFPSCount/district/${districtUid}/from/${requestData.from}/to/${requestData.to}`;
        } else if (districtUid && subDivisionUid && !blockUid && !panchayatUid) {
            apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/inspectionScheduling/getAllocatedFPSCount/subDivision/${subDivisionUid}/from/${requestData.from}/to/${requestData.to}`;
        } else if (districtUid && subDivisionUid && blockUid && !panchayatUid) {
            apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/inspectionScheduling/getAllocatedFPSCount/block/${blockUid}/from/${requestData.from}/to/${requestData.to}`;
        } else if (districtUid && subDivisionUid && blockUid && panchayatUid) {
            apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/inspectionScheduling/getAllocatedFPSCount/panchayat/${panchayatUid}/from/${requestData.from}/to/${requestData.to}`;
        }
        else {
            apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/inspectionScheduling/getAllocatedFPSCount/district/All/from/${requestData.from}/to/${requestData.to}`;
        }


        //  Make the API request
        axios
            .post(apiUrl, requestData, {

                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',  // Ensure content type is set
                }

            })

            .then((response) => {
                setIsLoading(false);
                if (response.data) {
                    setDataAvailable(true);
                    const mappedData = response.data.map((item, index) => {
                        // Calculate percentage (fpsCount / totalFps * 100)
                        const totalFps = item.totalFps || 0;
                        const fpsCount = parseInt(item.fpsCount) || 0;
                        const percentage = totalFps > 0 ? (fpsCount / totalFps) * 100 : 0;
                        return {
                            districtName: capitalizeFirstLetter(item.districtName || ''),
                            // districtId: item.districtId,
                            districtId: item.districtUid,
                            subDivisionName: capitalizeFirstLetter(item.subDivisionName || ''),
                            blockName: capitalizeFirstLetter(item.blockName || ''),
                            panchayatName: capitalizeFirstLetter(item.panchayatName || ''),
                            totalFps: item.totalFps,
                            fpsCount: parseInt(item.fpsCount) || "0",
                            percentageAllocation: percentage.toFixed(2) + "%",
                            assignedBy: item.assignedBy,
                            assignedTo: item.assignedTo,
                            inspectionDate: formatDateTable(item.dateOfInspection),
                        };
                    });
                    // console.log("mappedData", mappedData);
                    if (mappedData.length > 0) {
                        const sortedData = mappedData.sort((a, b) =>
                            a.districtName.localeCompare(b.districtName)
                        );
                        const totalFPSCount = sortedData.reduce((total, item) => total + parseInt(item.fpsCount || 0), 0);
                        const totalFps = sortedData.reduce((total, item) => total + parseInt(item.totalFps || 0), 0);
                        const percentageAll = totalFPSCount / totalFps * 100;
                        // Add the total row
                        const dataWithTotal = [...sortedData, {
                            sno: null,
                            districtName: 'Total',
                            subDivisionName: '',
                            blockName: '',
                            panchayatName: '',
                            totalFps: formatNumber(parseInt(totalFps) || "0"),
                            fpsCount: formatNumber(parseInt(totalFPSCount) || "0"),
                            percentageAllocation: percentageAll.toFixed(2) + '%',
                            assignedBy: '',
                            assignedTo: '',
                            inspectionDate: ''
                        }];

                        setDataAvailable(true);
                        setData(dataWithTotal);
                    } else {
                        setDataAvailable(false);
                        setData([]);
                        setError("No data available for the selected filters.");
                    }

                } else {
                    setDataAvailable(false);
                    setData([]);
                    setError("No data available for the selected filters.");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching report.");
                setDataAvailable(false);
                setData([]);
            });

        setShowTable(true);
        setShowDownloadButton(true);
    };


    useEffect(() => {
        if (data.length > 0) {
            setDataAvailable(true);
        } else {
            setDataAvailable(false);
        }
    }, [data]);

    // Controlled dropdown open/close
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    // Helper function to format the date as 'YYYY-MM-DD'
    const formatDate = (date) => {
        // Ensure the date is a valid date object before formatting
        if (date instanceof Date && !isNaN(date)) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return date.toLocaleDateString('en-GB', options).split('/').reverse().join('-'); // Format: 'YYYY-MM-DD'
        }
        return ''; // Return an empty string if the date is invalid
    };

    const handleDistrictClick = (district) => {
        // Check if district is 'All' and handle accordingly
        const districtId = district.districtId || districtUid;  // If districtUid is null or undefined, use 'All'

        // console.log("Selected District ID:", districtId);  // Log the selected district ID value

        setSelectedDistrict(district);
        // console.log("when i click district ", district);
        setIsLoading(true);

        const requestData = {};

        if (startDate) {
            requestData.from = formatDate(startDate);
        }
        if (endDate) {
            requestData.to = formatDate(endDate);
        }
        if (districtId) {
            requestData.districtUid = districtId;
        }
        if (username) {
            requestData.assignedBy = username; // Add the Assigned By ID
        }
        // if (username) {
        //     requestData.assignedTo = username; // Add the Assigned To ID
        // }
        if (usernameTo) {
            requestData.assignedTo = usernameTo; // Add the Assigned To ID
        }

        //  console.log("districtId", districtId);
        //  console.log("districtUid", districtUid);

        // Fetch the subdivision data based on the selected district
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/inspectionScheduling/getAllocatedFPSCount/drilldown/district/${districtUid || districtId}/from/${requestData.from}/to/${requestData.to}`, requestData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                setIsLoading(false);
                if (response.data) {
                    setSubdivisionData(response.data);
                } else {
                    setError("No subdivisions found for this district.");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching subdivision data.");
            });
    };



    const handleSubDivisionClick = (subdivision) => {
        //  console.log("Subdivision Object:", subdivision);  // Log the whole object to verify it

        // Instead of using subDivisionUid, use subDivision or find another unique identifier
        const subDivisionUId = subdivision.subDivisionUid ? subdivision.subDivisionUid : subdivision.subDivisionId;  // Use the subdivision name here
        const subDivisionUIdDrop = subDivisionUid;
        const subDivisionCount = subdivision.fpsCount;  // Optionally, you can log the fpsCount for debugging


        if (!subDivisionUId && !subDivisionUIdDrop) {
            console.error("Both subDivisionUId and subDivisionUIdDrop are missing or undefined");
            return;  // Exit early if neither of the identifiers are available
        }

        // Set the URL parameter conditionally
        const subdivisionIdToUse = subDivisionUId || subDivisionUIdDrop;  // Use subDivisionUId if available, otherwise fallback to subDivisionUIdDrop
        setIsLoading(true);
        setSelectedSubdivision(subdivision);
        const requestData = {};
        if (startDate) {
            requestData.from = formatDate(startDate);
        }
        if (endDate) {
            requestData.to = formatDate(endDate);
        }
        if (subdivisionIdToUse) {
            requestData.subDivisionUid = subdivisionIdToUse;

        }
        if (username) {
            requestData.assignedBy = username; // Add the Assigned By ID
        }
        // if (username) {
        //     requestData.assignedTo = username; // Add the Assigned To ID
        // }
        if (usernameTo) {
            requestData.assignedTo = usernameTo; // Add the Assigned To ID
        }

        // Update API call to use subDivisionName (or other property) instead of subDivisionUid
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/inspectionScheduling/getAllocatedFPSCount/drilldown/subDivision/${subdivisionIdToUse}/from/${requestData.from}/to/${requestData.to}`, requestData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                setIsLoading(false);
                if (response.data) {
                    setBlockData(response.data);
                } else {
                    setError("No data found for the selected subdivision.");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching subdivision details.");
            });
    };
    const handleBlockClick = (block) => {
        // console.log("Block clicked:", block);
        // console.log("Selected District:", selectedDistrict);
        // console.log("Selected Subdivision:", selectedSubdivision);
        // console.log("Selected Block:", selectedBlock);  // Ensure this is the block, not district or subdivision
        const blockId = block.blockUid;
        const blockIdDrop = blockUid;  // Ensure you are getting the correct blockId

        if (!blockId && !blockIdDrop) {
            console.error("Block ID is missing or undefined");
            return;  // Early exit if blockId is invalid
        }
        const blockIdToUse = blockId || blockIdDrop;
        setIsLoading(true);
        setSelectedBlock(block);

        // const requestData = {
        //     from: startDate ? formatDate(startDate) : undefined,
        //     to: endDate ? formatDate(endDate) : undefined,

        // };

        const requestData = {};
        if (startDate) {
            requestData.from = formatDate(startDate);
        }
        if (endDate) {
            requestData.to = formatDate(endDate);
        }
        if (blockIdToUse) {
            requestData.blockUid = blockId;
        }
        if (username) {
            requestData.assignedBy = username; // Add the Assigned By ID
        }
        // if (username) {
        //     requestData.assignedTo = username; // Add the Assigned To ID
        // }
        if (usernameTo) {
            requestData.assignedTo = usernameTo; // Add the Assigned To ID
        }

        axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/inspectionScheduling/getAllocatedFPSCount/drilldown/block/${blockIdToUse}/from/${requestData.from}/to/${requestData.to}`, requestData, {
            headers: { Authorization: `Bearer ${token}` },

            'Content-Type': 'application/json',
        })
            .then((response) => {
                setIsLoading(false);
                if (response.data) {
                    setPanchayatData(response.data);  // Ensure you update the correct state for Panchayat data
                } else {
                    setError("No data found for the selected block.");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching block details.");
            });
    };


    const handlePanchayatClick = (panchayat) => {
        // console.log("Panchayat Object:", panchayat);  // Log the whole object to verify it

        // Use panchayatId or another unique identifier for the panchayat
        const panchayatId = panchayat.panchayatUid ? panchayat.panchayatUid : panchayat.panchayatId;
        const panchayatDropId = panchayatUid
        const panchayatCount = panchayat.fpsCount;  // Optionally, log the fpsCount for debugging

        if (!panchayatId && !panchayatDropId) {
            console.error("Panchayat ID is missing or undefined");
            return;  // Early exit if panchayatId is not valid
        }
        const panchayatIdToUse = panchayatId || panchayatDropId;

        setIsLoading(true);
        setSelectedPanchayat(panchayat);
        const requestData = {};

        if (startDate) {
            requestData.from = formatDate(startDate);
        }
        if (endDate) {
            requestData.to = formatDate(endDate);
        }
        if (panchayatIdToUse) {
            requestData.panchayatUid = panchayatIdToUse;
        }
        if (username) {
            requestData.assignedBy = username; // Add the Assigned By ID
        }
        // if (username) {
        //     requestData.assignedTo = username; // Add the Assigned To ID
        // }
        if (usernameTo) {
            requestData.assignedTo = usernameTo; // Add the Assigned To ID
        }

        // API call to fetch data related to panchayatId
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/inspectionScheduling/getAllocatedFPSCount/drilldown/panchayat/${panchayatIdToUse}/from/${requestData.from}/to/${requestData.to}`, requestData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((response) => {
                setIsLoading(false);
                if (response.data) {
                    setAfterPanchayatData(response.data);  // Handle the response as needed
                } else {
                    setError("No data found for the selected panchayat.");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setError("Error fetching panchayat details.");
            });
    };

    // Handle Back navigation to the previous table
    const handleGoBack = () => {
        if (selectedPanchayat) {
            // Go back from Assigned Data for Panchayat to Panchayat table
            setSelectedPanchayat(null); // Reset Panchayat selection
            setAfterPanchayatData([]);  // Clear the assigned data
        } else if (selectedBlock) {
            // Go back from Panchayat to Block table
            setSelectedBlock(null); // Reset Block selection
            setPanchayatData([]);   // Clear Panchayat data
        } else if (selectedSubdivision) {
            // Go back from Block to Subdivision table
            setSelectedSubdivision(null); // Reset Subdivision selection
            setBlockData([]);  // Clear Block data
        } else if (selectedDistrict) {
            // Go back from Subdivision to District table
            setSelectedDistrict(null); // Reset District selection
            setSubdivisionData([]);   // Clear Subdivision data
        }
    };



    const getDistrictName = (districtUid) => {
        const district = districts.find(d => d.districtUid === districtUid);
        return district ? district.districtName : districtUid;
    };

    // Function to get the subdivision name based on subDivisionUid
    const getSubDivisionName = (subDivisionUid) => {
        const subdivision = subDivisions.find(sd => sd.subDivisionUid === subDivisionUid);
        return subdivision ? subdivision.subDivisionName : subDivisionUid;
    };

    // Function to get the block name based on blockUid
    const getBlockName = (blockUid) => {
        const block = blocks.find(b => b.blockUid === blockUid);
        return block ? block.blockName : blockUid;
    };
    const getPanchayatName = (panchayatUid) => {
        const panchayat = panchayats.find(b => b.panchayatUid === panchayatUid);
        return panchayat ? panchayat.panchayatName : panchayatUid;
    };
    const generatePDF = () => {
        const doc = new jsPDF({
            unit: 'mm', // units in mm (millimeters)
            format: [210, 260] // A4 size: 210mm x 297mm (you can customize it to larger size like letter: [216, 279])
        });

        doc.setFontSize(18);
        doc.addImage(pds, 'jpeg', 9.5, 10, 190, 30);  // Image format: 'PNG'

        const pageWidth = doc.internal.pageSize.width;

        // Set the background color for the title and move it down
        const backgroundYPosition = 40.2; // New y-position for the background fill
        doc.setFillColor(211, 211, 211); // RGB values for 'whitesmoke'
        doc.rect(10, backgroundYPosition, pageWidth - 20, 15, 'F'); // Draw a filled rectangle with the new y-position

        // Set the report title with a styled color
        const title = 'Inspection Allocation Report';  // Title for the report
        const titleWidth = doc.getTextWidth(title); // Get the width of the title

        // Set title text color to #2a6d8b
        doc.setTextColor(42, 109, 139);  // RGB values for #2a6d8b
        doc.setFontSize(14.4);
        const titleYPosition = backgroundYPosition + 10; // Adjusted y-position for the title, below the background
        doc.text(title, (pageWidth - titleWidth) / 2, titleYPosition); // Position the title at the new y position

        // Define your district, subdivision, block, and panchayat data
        const district = districts.find(d => String(d.id) === String(districtId));
        const subDivision = subDivisions.find(s => String(s.id) === String(subDivisionId));
        const block = blocks.find(b => String(b.id) === String(blockId));
        const panchayat = panchayats.find(p => String(p.id) === String(panchayatId));
        const assignedByOfficer = inspectionOfficers.find(officer => officer.id === assignedById);
        const assignedToOfficer = inspectionOfficers.find(officer => officer.id === assignedToId);

        const districtName = district ? district.districtName : '';
        const subDivisionName = subDivision ? subDivision.subDivisionName : '';
        const blockName = block ? block.blockName : '';
        const panchayatName = panchayat ? panchayat.panchayatName : '';
        const assignedByName = assignedByOfficer ? assignedByOfficer.fullname : '';
        const assignedToName = assignedToOfficer ? assignedToOfficer.fullname : '';
        // Access the full name directly from your payload (data variable)
        // const userFullname = data && data[0] ? data[0].fullName : ' ';

        // Date formatting (if dates are present)
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        // Set the font size and text color for the content
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);  // Set text color to black

        // table td height define for y and x is moving rightside
        let currentYPosition = 55.21;
        let xPosition = 10;

        // Define the space between columns
        const columnSpacing = 63.2; // Space between columns

        // Draw the first table (District, Sub Division, Block, etc.)
        const tableHeight = 8;  // Row height for each line
        const tableWidth = columnSpacing * 3;  // Table width based on the number of columns

        // Draw table headers with borders between columns (only if data exists)
        doc.rect(xPosition, currentYPosition, tableWidth, tableHeight);  // Top border of the table

        // Set font to normal for labels (District:, Sub Division:, Block:)
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);  // Set text color to black for labels

        let hasDistrict = districtName !== '';
        let hasSubDivision = subDivisionName !== '';
        let hasBlock = blockName !== '';

        // Add labels only if data exists for the fields
        if (hasDistrict) {
            doc.text("District:", xPosition + 5, currentYPosition + 5);
        }
        if (hasSubDivision) {
            doc.text("Sub Division:", xPosition + 15 + columnSpacing, currentYPosition + 5);
        }
        if (hasBlock) {
            doc.text("Block:", xPosition + columnSpacing * 2.25, currentYPosition + 5);
        }

        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);  // Blue color for dynamic data

        // Add dynamic data only if the corresponding field exists
        if (hasDistrict) {
            doc.text(capitalizeFirstLetter(districtName), xPosition + 28, currentYPosition + 5);  // District name (dynamic)
        }
        if (hasSubDivision) {
            doc.text(capitalizeFirstLetter(subDivisionName), xPosition + columnSpacing * 1.65, currentYPosition + 5);  // Sub Division name (dynamic)
        }
        if (hasBlock) {
            doc.text(capitalizeFirstLetter(blockName), xPosition + columnSpacing * 2.02 + 28, currentYPosition + 5);  // Block name (dynamic)
        }

        // Move down for the next row
        currentYPosition += tableHeight;  // Move down for the next row

        // Draw the second table (Panchayat, FPS ID, Dates)
        const tableHeight2 = 8;  // Row height for each line
        const tableWidth2 = columnSpacing * 3;  // Table width for this table

        currentYPosition += tableHeight - 8;  // Add some space between the two tables

        let currentTableHeight = 0;
        if (panchayatName || assignedByName || assignedToName) {  //|| userFullname
            doc.rect(xPosition, currentYPosition, tableWidth2, tableHeight2);  // Top border of the second table

            // Set font to normal for labels (Panchayat, FPS ID)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            let hasPanchayat = panchayatName !== '';
            let hasFullname = assignedByName !== '';
            let hasFullnameTo = assignedToName !== '';

            // Add labels only if data exists
            if (hasPanchayat) {
                doc.text("Panchayat:", xPosition + 5, currentYPosition + 5);
            }
            if (hasFullname) {
                doc.text("Assigned By:", xPosition + columnSpacing * 1.2, currentYPosition + 5);
            }
            if (hasFullnameTo) {
                doc.text("Assigned To:", xPosition + columnSpacing * 2.05, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Green color for dynamic data

            // Add dynamic data only if the corresponding field exists
            if (hasPanchayat) {
                doc.text(capitalizeFirstLetter(panchayatName), xPosition + 28, currentYPosition + 5);  // Panchayat name (first name)
            }
            if (hasFullname) {
                doc.text(formatFullName(assignedByName), xPosition + columnSpacing * 1.60, currentYPosition + 5);  // Assigned By (dynamic)
            }
            if (hasFullnameTo) {
                doc.text(formatFullName(assignedToName), xPosition + columnSpacing * 2.02 + 28, currentYPosition + 5);  // Assigned To (dynamic)
            }
            // Move down for the next row
            currentYPosition += tableHeight2;
            currentTableHeight = tableHeight2; // Update table height for the second table
        }

        // Check if the second table doesn't have data, then directly show third table (From Date, To Date)
        const tableHeight3 = 8;  // Row height for the third table
        const hasFromDate = fromDate !== '';
        const hasToDate = toDate !== '';

        if (!currentTableHeight || hasFromDate || hasToDate) {
            doc.rect(xPosition, currentYPosition, tableWidth2, tableHeight3);  // Top border of the third table

            // Set font to normal for labels (From Date, To Date)
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);  // Set text color to black for labels

            if (hasFromDate) {
                doc.text("From Date:", xPosition + 5, currentYPosition + 5);
            }
            if (hasToDate) {
                doc.text("To Date:", xPosition + columnSpacing + 15, currentYPosition + 5);
            }

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0, 0, 0);  // Orange color for dynamic data

            if (hasFromDate) doc.text(fromDate, xPosition + 28, currentYPosition + 5);  // From Date (dynamic)
            if (hasToDate) doc.text(toDate, xPosition + columnSpacing * 1.55, currentYPosition + 5);  // To Date (dynamic)

            currentYPosition += tableHeight3;
        } else {
            currentYPosition += currentTableHeight;
        }
        currentYPosition += 5;  // Adjust space for next content if needed

        // Add the current date and time to the PDF
        const currentDate = new Date();
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);
        doc.text(`Report Date: ${formattedDateTime}`, pageWidth - 11, currentYPosition + 3, { align: 'right' });

        // Add a space after the title

        let tableTitle = "";


        // Check the current filter selection to create a proper title
        if (selectedDistrict && selectedSubdivision && selectedBlock && selectedPanchayat) {
            // If all filters (District, Subdivision, Block, and Panchayat) are selected
            tableTitle = `${capitalizeFirstLetter(selectedDistrict.districtName) || getDistrictName(districtUid)} - ${capitalizeFirstLetter(selectedSubdivision.subDivisionName) || getSubDivisionName(subDivisionUid)} - ${capitalizeFirstLetter(selectedBlock.blockName) || getBlockName(blockUid)} - ${capitalizeFirstLetter(selectedPanchayat.panchayatName)}`;
        } else if (selectedDistrict && selectedSubdivision && selectedBlock) {
            // If District, Subdivision, and Block are selected (but not Panchayat)
            tableTitle = `${capitalizeFirstLetter(selectedDistrict.districtName) || getDistrictName(districtUid)} - ${capitalizeFirstLetter(selectedSubdivision.subDivisionName) || getSubDivisionName(subDivisionUid)} - ${capitalizeFirstLetter(selectedBlock.blockName) || getBlockName(blockUid)} - Panchayats`;
        } else if (selectedDistrict && selectedSubdivision) {
            // If District and Subdivision are selected (but not Block or Panchayat)
            tableTitle = `${capitalizeFirstLetter(selectedDistrict.districtName) || getDistrictName(districtUid)} - ${capitalizeFirstLetter(selectedSubdivision.subDivisionName) || getSubDivisionName(subDivisionUid)} - Blocks`;
        } else if (selectedDistrict && !selectedSubdivision && !selectedBlock) {
            // If only District is selected
            tableTitle = `${capitalizeFirstLetter(selectedDistrict.districtName) || getDistrictName(districtUid)} - Subdivisions`;
        } else if (selectedDistrict && selectedSubdivision && !selectedBlock && !selectedPanchayat) {
            // If only District and Subdivision are selected, but neither Block nor Panchayat
            tableTitle = `${capitalizeFirstLetter(selectedDistrict.districtName) || getDistrictName(districtUid)} - ${capitalizeFirstLetter(selectedSubdivision.subDivisionName) || getSubDivisionName(subDivisionUid)} - Blocks`;
        } else {
            // Ensure that you are checking for undefined or null values gracefully before using them
            const districtName = selectedDistrict ? selectedDistrict.districtName : getDistrictName(districtUid);
            const subdivisionName = selectedSubdivision ? selectedSubdivision.subDivisionName : getSubDivisionName(subDivisionUid);
            const blockName = selectedBlock ? selectedBlock.blockName : getBlockName(blockUid);
            const panchayatName = selectedPanchayat ? capitalizeFirstLetter(selectedPanchayat.panchayatName).trim() : "";

            // Start constructing the tableTitle
            // let tableTitle = "";

            // Add District Name only if it's selected
            if (districtName) {
                tableTitle += `${capitalizeFirstLetter(districtName)}`;
            }

            // Add Subdivision Name if it's selected
            if (subdivisionName) {
                // Append a dash between the sections if both District and Subdivision are present
                if (tableTitle) tableTitle += " - ";
                tableTitle += `${capitalizeFirstLetter(subdivisionName)} - Blocks`;
                // if (tableTitle.endsWith(" - Blocks")) {
                //     tableTitle = tableTitle.slice(0, -" - Blocks".length);
                // }
            }

            // Add Block Name if it's selected
            // if (blockName || getBlockName(blockUid)) {
            //     // Append a dash between the sections if both District/Subdivision and Block are present
            //     if (tableTitle) tableTitle += " - ";
            //     tableTitle += `${capitalizeFirstLetter(blockName) || getBlockName(blockUid)} `;
            // }

            if (blockName || getBlockName(blockUid)) {
                // Append a dash between the sections if both District/Subdivision and Block are present
                if (tableTitle.endsWith(" - Blocks")) {
                    tableTitle = tableTitle.slice(0, -" - Blocks".length);
                }
                // Add the block name with "- Panchayat"
                tableTitle += ` - ${capitalizeFirstLetter(blockName) || getBlockName(blockUid)} - Panchayats`;

                // Remove the last "- Panchayat" from the string (if it exists)
                // if (tableTitle.endsWith(" - Panchayat")) {
                //     tableTitle = tableTitle.slice(0, -" - Panchayat".length);
                // }
            }

            // Add Panchayat Name if it's selected
            if (panchayatName || getPanchayatName(panchayatUid)) {
                // Append a dash between the sections if both District/Subdivision/Block and Panchayat are present
                if (tableTitle.endsWith(" - Panchayats")) {
                    tableTitle = tableTitle.slice(0, -" - Panchayats".length);
                }
                tableTitle += ` - ${panchayatName || getPanchayatName(panchayatUid)}`;
            }

            // If no values are selected, the title will remain empty
            tableTitle = tableTitle || "No selection made";
        }


        // This ensures the title reflects the correct context based on the filters


        // Add the title to the PDF before the table
        doc.text(tableTitle, 14, currentYPosition + 9); // Position the title above the table

        currentYPosition += 6;

        // Define table headers and rows based on the current view (District, Subdivision, Block, or Panchayat)
        let headers = [];
        let rows = [];
        let totalFPSCount = 0;  // Variable to store the total FPS fpsCount for each table
        let totalFps1 = 0;  // Variable to store the total FPS fpsCount for each table
        let Percentage = 0;  // Variable to store the total FPS fpsCount for each table
        // Check which level of data is being displayed and populate the headers and rows accordingly
        if (!selectedDistrict && !selectedSubdivision && !selectedBlock) {
            // District Table
            // Add 'S. No' as the first header
            headers = ['S. No', ...columns.map(column => column.Header)];

            // Map over the data to include the serial number in each row
            rows = data.map((row, index) => {
                // Add the serial number as the first column for each row
                return [
                    index + 1, // Serial number
                    ...columns.map(column => {
                        return column.accessor === 'sno' ? index + 1 : row[column.accessor] || '-';
                    })
                ];
            });
        }   // Check which level of data is being displayed and populate the headers and rows accordingly
        if (!selectedDistrict && !selectedSubdivision && !selectedBlock) {
            // District Table
            // Add 'S. No' as the first header
            headers = ['S. No', ...columns.map(column => column.Header)];

            // Map over the data to include the serial number in each row
            rows = data.map((row, index) => {
                // Add the serial number as the first column for each row
                return [
                    index + 1, // Serial number
                    ...columns.map(column => {
                        return column.accessor === 'sno' ? index + 1 : row[column.accessor] || '-';
                    })
                ];
            });
        }   // Check which level of data is being displayed and populate the headers and rows accordingly
        if (!selectedDistrict && !selectedSubdivision && !selectedBlock) {
            // District Table
            // Add 'S. No' as the first header
            headers = ['S. No', ...columns.map(column => column.Header)];

            // Map over the data to include the serial number in each row
            rows = data.map((row, index) => {
                // If this is the total row, don't include sno, but include the other columns
                if (row.districtName === 'Total') {
                    return [
                        // No serial number for the total row
                        ' ',
                        ...columns.map(column => {
                            // For the "Total" row, just display the values for the other columns
                            return row[column.accessor] || ' ';
                        })
                    ];
                }

                // For other rows, include the serial number
                return [
                    index + 1, // Serial number
                    ...columns.map(column => {
                        return column.accessor === 'sno' ? index + 1 : row[column.accessor] || '-';
                    })
                ];
            });
        }


        else if (selectedDistrict && !selectedSubdivision && !selectedBlock) {
            // Subdivision Table
            headers = ['S.No', 'Sub-Division', 'Total No. of FPS', 'No .of Allocation', '% Allocation'];
            rows = subdivisionData.map((subdivision, index) => {
                const fpsCount = parseInt(subdivision.fpsCount) || 0;
                totalFPSCount += fpsCount;  // Add to the total FPS fpsCount
                const totalFps = parseInt(subdivision.totalFps) || 0;  // Ensure totalFps is a number
                totalFps1 += totalFps;  // Add to the total FPS fpsCount
                Percentage = (totalFPSCount / totalFps1 * 100).toFixed(2) + '%';  // Calculate percentage
                return [
                    index + 1,
                    capitalizeFirstLetter(subdivision.subDivisionName),
                    totalFps,
                    fpsCount,
                    (fpsCount / subdivision.totalFps * 100).toFixed(2) + '%'
                ];
            });
        } else if (selectedSubdivision && !selectedBlock) {
            // Block Table
            headers = ['S.No', 'Block', 'Total No. of FPS', 'No .of Allocation', '% Allocation'];
            rows = blockData.map((block, index) => {
                const fpsCount = parseInt(block.fpsCount) || 0;
                totalFPSCount += fpsCount;  // Add to the total FPS fpsCount
                const totalFps = parseInt(block.totalFps) || 0;  // Ensure totalFps is a number
                totalFps1 += totalFps;  // Add to the total FPS fpsCount
                Percentage = (totalFPSCount / totalFps1 * 100).toFixed(2) + '%';  // Calculate percentage
                return [
                    index + 1,
                    capitalizeFirstLetter(block.blockName),
                    totalFps,
                    fpsCount,
                    (fpsCount / block.totalFps * 100).toFixed(2) + '%'
                ];
            });
        } else if (selectedBlock && !selectedPanchayat) {
            // Panchayat Table
            headers = ['S.No', 'Panchayat', 'Total No. of FPS', 'No .of Allocation', '% Allocation'];
            rows = panchayatData.map((panchayat, index) => {
                const fpsCount = parseInt(panchayat.fpsCount) || 0;
                totalFPSCount += fpsCount;  // Add to the total FPS fpsCount
                const totalFps = parseInt(panchayat.totalFps) || 0;  // Ensure totalFps is a number
                totalFps1 += totalFps;  // Add to the total FPS fpsCount
                Percentage = (totalFPSCount / totalFps1 * 100).toFixed(2) + '%';  // Calculate percentage
                return [
                    index + 1,
                    capitalizeFirstLetter(panchayat.panchayatName.trim()),
                    totalFps,
                    fpsCount,
                    (fpsCount / panchayat.totalFps * 100).toFixed(2) + '%'
                ];
            });
        } else if (afterpanchayatData.length > 0) {
            // Assigned Data for Panchayat Table
            headers = ['Assigned By', 'Assigned To', 'Date of Inspection', 'FPS ID'];
            rows = afterpanchayatData.map((item, index) => {
                const fpsId = parseInt(item.fpsId) || 0;
                // totalFPSCount += fpsId;  // Add to the total FPS fpsCount
                return [
                    formatFullName(item.assignedBy),
                    formatFullName(item.assignedTo),
                    formatDateTable(item.dateOfInspection),
                    // item.totalFps,
                    fpsId,
                    // (fpsCount / item.totalFps * 100).toFixed(2) + '%'
                ];
            });
        }

        // Add Total FPS Count row at the bottom of the table
        if (totalFPSCount > 0) {
            // Ensure the total FPS fpsCount is placed in the last column
            let totalRow = ['', 'Total FPS Count'];  // For non-final columns, leave blank
            while (totalRow.length < headers.length - 3) {
                totalRow.push(''); // Fill in empty cells if there are more columns
            }
            totalRow.push(totalFps1);  // Insert total in the last column
            totalRow.push(totalFPSCount);  // Insert total in the last column
            totalRow.push(Percentage);  // Insert total in the last column
            rows.push(totalRow);  // Push the total row to the rows array
        }

        // Add Table Data to PDF
        doc.autoTable({
            startY: currentYPosition + 5,
            head: [headers],
            body: rows,
            theme: 'grid',
            styles: { fontSize: 10 },
            headStyles: { fillColor: [42, 109, 139] },
            columnStyles: {
                0: { halign: 'center' }, // S.No column centered
            },
            didParseCell: function (data) {
                const value = data.cell.text; // Get the value of the current cell
                const colIndex = data.column.index; // Get the current column index

                if (colIndex !== 0) { // S.No column should remain centered
                    // Check if value is a number or date
                    if (!isNaN(value) || value instanceof Date) {
                        // Align numbers and dates to the right
                        data.cell.styles.halign = 'right';
                    } else {
                        // Align strings (or other types) to the left
                        data.cell.styles.halign = 'left';
                    }
                }
            },
        });

        // Save the PDF
        // doc.save("Inspection_Allocation_Report.pdf");
        doc.save("Inspections_Allocation_Report.pdf");
    };
    const generateExcel = () => {
        const currentDate = new Date();
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        // Date formatting (if dates are present)
        const fromDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear().toString().slice()}` : '';
        const toDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear().toString().slice()}` : '';

        // 2. Generate Excel file using ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Inspection Allocation Report');

        let headers = [];
        let rows = [];
        let totalFpsCount = 0;  // Variable to store the total FPS fpsCount
        let totalFps1 = 0;  // Variable to store the total FPS fpsCount
        let Percentage = 0;  // Variable to store the total FPS fpsCount
        // Dynamically generate headers and rows based on conditions
        if (!selectedDistrict && !selectedSubdivision && !selectedBlock) {
            // District Table
            // Add 'S. No' as the first header
            headers = ['S. No', ...columns.map(column => column.Header)];

            // Map over the data to include the serial number in each row
            rows = data.map((row, index) => {
                if (row.districtName === 'Total') {
                    return [
                        ' ', // No serial number for the total row
                        ...columns.map(column => row[column.accessor] || ' ')
                    ];
                }

                return [
                    index + 1, // Serial number
                    ...columns.map(column => row[column.accessor] || '-')
                ];
            });
        } else if (selectedDistrict && !selectedSubdivision && !selectedBlock) {
            // Subdivision Table
            headers = ['S.No', 'Sub-Division', 'Total No. of FPS', 'No .of Allocation', '% Allocation'];
            rows = subdivisionData.map((subdivision, index) => {
                totalFpsCount += parseInt(subdivision.fpsCount) || 0; // Add FPS fpsCount to total
                const totalFps = parseInt(subdivision.totalFps) || 0;  // Ensure totalFps is a number
                totalFps1 += totalFps;  // Add to the total FPS fpsCount
                Percentage = (totalFpsCount / totalFps1 * 100).toFixed(2) + '%';  // Calculate percentage
                return [
                    index + 1,
                    capitalizeFirstLetter(subdivision.subDivisionName),
                    totalFps,
                    subdivision.fpsCount || 0,
                    (subdivision.fpsCount / subdivision.totalFps * 100).toFixed(2) + '%'
                ];
            });
        } else if (selectedSubdivision && !selectedBlock) {
            // Block Table
            headers = ['S.No', 'Block', 'Total No. of FPS', 'No .of Allocation', '% Allocation'];
            rows = blockData.map((block, index) => {
                totalFpsCount += parseInt(block.fpsCount) || 0; // Add FPS fpsCount to total
                const totalFps = parseInt(block.totalFps) || 0;  // Ensure totalFps is a number
                totalFps1 += totalFps;  // Add to the total FPS fpsCount
                Percentage = (totalFpsCount / totalFps1 * 100).toFixed(2) + '%';  // Calculate percentage
                return [
                    index + 1,
                    capitalizeFirstLetter(block.blockName),
                    totalFps,
                    block.fpsCount || 0,
                    (block.fpsCount / block.totalFps * 100).toFixed(2) + '%'
                ];
            });
        } else if (selectedBlock && !selectedPanchayat) {
            // Panchayat Table
            headers = ['S.No', 'Panchayat', 'Total No. of FPS', 'No .of Allocation', '% Allocation'];
            rows = panchayatData.map((panchayat, index) => {
                totalFpsCount += parseInt(panchayat.fpsCount) || 0; // Add FPS fpsCount to total
                const totalFps = parseInt(panchayat.totalFps) || 0;  // Ensure totalFps is a number
                totalFps1 += totalFps;  // Add to the total FPS fpsCount
                Percentage = (totalFpsCount / totalFps1 * 100).toFixed(2) + '%';  // Calculate percentage
                return [
                    index + 1,
                    capitalizeFirstLetter(panchayat.panchayatName.trim()),
                    totalFps,
                    panchayat.fpsCount || 0,
                    (panchayat.fpsCount / panchayat.totalFps * 100).toFixed(2) + '%'
                ];
            });
        } else if (afterpanchayatData.length > 0) {
            // Assigned Data for Panchayat Table
            headers = ['Assigned By', 'Assigned To', 'Date of Inspection', 'FPS ID'];
            rows = afterpanchayatData.map((item, index) => {
                // totalFpsCount += parseInt(item.fpsCount) || 0; // Add FPS fpsCount to total
                return [
                    formatFullName(item.assignedBy),
                    formatFullName(item.assignedTo),
                    formatDateTable(item.dateOfInspection),
                    // item.totalFps,
                    item.fpsId,
                    // (item.fpsCount / item.totalFps * 100).toFixed(2) + '%'
                ];
            });
        }

        // Dynamically adjust the merge for title and report date based on the number of columns
        const numberOfColumns = headers.length;
        worksheet.mergeCells(`A1:${String.fromCharCode(64 + numberOfColumns)}1`);
        worksheet.getCell('A1').value = `Inspection Allocation Report`;
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'F7912B' } };
        worksheet.getCell('A1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F5F5F5' } };

        worksheet.mergeCells(`A2:${String.fromCharCode(64 + numberOfColumns)}2`);
        worksheet.getCell('A2').value = `Report Date : ${formattedDateTime}`;
        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };
        worksheet.getCell('A2').font = { size: 16, bold: true, color: { argb: '000000' } };
        worksheet.getCell('A2').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F5F5F5' } };

        worksheet.mergeCells(`A3:${String.fromCharCode(64 + numberOfColumns)}3`);
        worksheet.getCell('A3').value = `From Date: ${fromDate}                  To Date: ${toDate}`;
        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell('A3').font = { size: 12, bold: true, color: { argb: '000000' } };
        worksheet.getCell('A3').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F5F5F5' } };

        // Add the header row to the worksheet
        worksheet.addRow(headers);

        // Apply header style: bold, size 12, and orange background
        const headerRow = worksheet.getRow(4);
        headerRow.font = { bold: true, size: 12 };
        headerRow.alignment = { horizontal: 'center' };

        // Apply background color and borders to the header cells
        headers.forEach((_, colIndex) => {
            const cell = worksheet.getCell(4, colIndex + 1); // Get each cell in the header row
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFA500' } }; // Orange background color
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } }; // White text color
            cell.border = { top: { style: 'thin', color: { argb: '000000' } }, left: { style: 'thin', color: { argb: '000000' } }, bottom: { style: 'thin', color: { argb: '000000' } }, right: { style: 'thin', color: { argb: '000000' } } };
        });

        // Add data rows dynamically based on the `columns` array
        rows.forEach((dataRow) => {
            worksheet.addRow(dataRow);
        });

        // If it's not the District Table, add the total row at the bottom
        if (selectedDistrict || selectedSubdivision || selectedBlock || selectedPanchayat || afterpanchayatData.length > 0) {
            if (headers.length === 4) {
                //worksheet.addRow(['', '', 'Total', '', totalFpsCount], '');  // For 4 columns
            } else if (headers.length === 5) {
                worksheet.addRow(['', 'Total', totalFps1, totalFpsCount, Percentage], '');  // For 3 columns
            } else {
                // Handle cases with other column numbers if needed
                worksheet.addRow([null, 'Total', '', '', totalFpsCount], '');  // Default case
            }

            // Apply styles for the total row (bold and centered)
            const totalRow = worksheet.lastRow;
            // totalRow.font = { bold: true, color: { argb: 'F7912B' }, fgColor: { argb: 'FFFFA500' } };
            totalRow.getCell(3).alignment = { horizontal: 'center' }; // Center the "Total" text
            totalRow.getCell(4).alignment = { horizontal: 'right' }; // Right align the total FPS fpsCount
        }

        // Apply alignment for each cell in the data row
        rows.forEach((dataRow, rowIndex) => {
            const addedRow = worksheet.getRow(rowIndex + 4); // Rows start from 4 (after title, date, and header)
            addedRow.eachCell((cell, colNumber) => {
                const column = columns[colNumber - 1]; // Get column information for each cell
                const value = cell.value;
                if (colNumber === 1) {
                    // Center alignment for S.No (serial number)
                    cell.alignment = { horizontal: 'center' };
                } else if (typeof value === 'number') {
                    // Right alignment for numeric columns (e.g., FPS fpsCount)
                    cell.alignment = { horizontal: 'right' };
                } else if (value instanceof Date) {
                    // Right alignment for date columns
                    cell.alignment = { horizontal: 'right' };
                } else {
                    // Left alignment for text columns
                    cell.alignment = { horizontal: 'left' };
                }
            });
        });

        // Set column widths based on the headers and data
        worksheet.columns = headers.map((header, index) => {
            const maxHeaderLength = header.length;
            const maxDataLength = rows.reduce((maxLength, row) => {
                const column = columns.find(col => col.Header === header);
                const cellValue = row[columns.indexOf(column)] || '';
                return Math.max(maxLength, String(cellValue).length);
            }, 0);

            const maxLength = Math.max(maxHeaderLength, maxDataLength) + 10; // +10 for extra padding

            return {
                key: String.fromCharCode(65 + index), // A, B, C, etc.
                width: maxLength, // Set column width
            };
        });

        // Save the file (Excel)
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'Inspection_Allocation_Report.xlsx';
            link.click();
        });
    };






    return (
        <div className="allocationReport-insepectionreport">
            <div className="allocationReport-card">
                <div className="allocationReport-card-header">Inspection Allocation Report</div>
                <div >
                    <div className="allocationReport-mainBlock">
                        <div className="allocationReport-group-cu ">
                            <label htmlFor="district" className="textitems"><span className="asterisk">*</span>District</label>
                            <Select
                                className="search-select-report"
                                id="district"
                                // Ensure you pass the selected option as an object with value and label
                                value={districts.find((dist) => dist.id === districtId) ? {
                                    value: districts.find((dist) => dist.id === districtId).id,
                                    label: capitalizeFirstLetter(districts.find((dist) => dist.id === districtId).districtName)
                                } : null}
                                onChange={handleDistrictChange}  // Handle the selection change
                                options={districts.sort((a, b) => a.districtName.localeCompare(b.districtName)).map((dist) => ({
                                    value: dist.id,
                                    label: capitalizeFirstLetter(dist.districtName),
                                    districtUid: dist.districtUid
                                }))}
                                placeholder="Select a district"
                                isSearchable // Enable search in the dropdown
                                styles={customStyles} // Apply custom styles here
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown} // Trigger dropdown open
                                onMenuClose={toggleDropdown} // Trigger dropdown close
                                isDisabled={isReportGenerated}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                        <div className="allocationReport-group-cu ">
                            <label htmlFor="subDivision">{/*<span className="asterisk">*</span>*/}Sub Division</label>
                            <Select
                                className="search-select-report"
                                id="subDivision"
                                value={subDivisionId ? {
                                    value: subDivisionId,
                                    label: capitalizeFirstLetter(subDivisions.find((sub) => sub.id === subDivisionId)?.subDivisionName)
                                } : null}
                                onChange={handleSubDivisionChange}
                                options={subDivisions.sort((a, b) => a.subDivisionName.localeCompare(b.subDivisionName)).map((sub) => ({
                                    value: sub.id,
                                    label: capitalizeFirstLetter(sub.subDivisionName),
                                    subDivisionUid: sub.subDivisionUid,
                                }))}
                                placeholder="Select Sub Division"
                                isSearchable
                                styles={customStyles}
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                isDisabled={isReportGenerated}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px", }}>

                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                        <div className="allocationReport-group-cu ">
                            <label htmlFor="block" className="textitems-2">{/*<span className="asterisk">*</span>*/}Block</label>
                            <Select
                                className="search-select-report"
                                id="block"
                                value={blockId ? {
                                    value: blockId,
                                    label: capitalizeFirstLetter(blocks.find((block) => block.id === blockId)?.blockName)
                                } : null}
                                onChange={handleBlockChange}
                                options={blocks.sort((a, b) => a.blockName.localeCompare(b.blockName)).map((block) => ({
                                    value: block.id,
                                    label: capitalizeFirstLetter(block.blockName),
                                    blockUid: block.blockUid,
                                }))}
                                placeholder="Select Block"
                                isSearchable
                                styles={customStyles}
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                isDisabled={isReportGenerated}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                    </div>
                    <div className="allocationReport-mainBlock">
                        <div className="allocationReport-group-cu " >
                            <label htmlFor="panchayat">{/*<span className="asterisk">*</span>*/}Panchayat</label>
                            <Select
                                className="search-select-report"
                                id="panchayat"
                                value={panchayatId ? {
                                    value: panchayatId,
                                    label: capitalizeFirstLetter(panchayats.find((p) => p.id === panchayatId)?.panchayatName)
                                } : null}
                                onChange={handlePanchayatChange}
                                options={panchayats.sort((a, b) => a.panchayatName.localeCompare(b.panchayatName)).map((p) => ({
                                    value: p.id,
                                    label: capitalizeFirstLetter(p.panchayatName),
                                    panchayatUid: p.panchayatUid,
                                }))}
                                placeholder="Select Panchayat"
                                isSearchable
                                styles={customStyles}
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                isDisabled={isReportGenerated}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: 'pointer', marginRight: '10px' }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: '20px', height: '20px' }}
                                            />
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                        <div className="allocationReport-group-cu "   /*style={{ visibility: "hidden" }}*/>
                            <label htmlFor="fps" className="textitems-1">{/*<span className="asterisk">*</span>*/}Assigned By</label>
                            <Select
                                className="search-select-report"
                                id="inspectionOfficer"
                                value={assignedById ? {
                                    value: assignedById,
                                    label: formatFullName(
                                        inspectionOfficers.find((officer) => officer.id === assignedById)?.fullname
                                    )
                                } : null}
                                onChange={handleInspectionOfficerChangeBy}
                                options={inspectionOfficers.sort((a, b) => a.fullname.localeCompare(b.fullname)).map((officer) => ({
                                    value: officer.id,
                                    label: formatFullName(officer.fullname),
                                    username: officer.username,
                                    poimsUserId: officer.id,


                                }))}
                                placeholder="Assigned By"
                                isSearchable
                                styles={customStyles}
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                isDisabled={isReportGenerated}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img
                                                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                                alt="Dropdown"
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                        <div className="allocationReport-group-cu "  /*style={{ visibility: "hidden" }}*/>
                            <label htmlFor="startDate" className="textitems-1"> {/*<span className="asterisk">*</span>*/}  Assigned To</label>
                            <Select
                                className="search-select-report"
                                id="inspectionOfficer"
                                value={assignedToId ? {
                                    value: assignedToId,
                                    label: formatFullName(
                                        inspectionOfficers.find((officer) => officer.id === assignedToId)?.fullname
                                    )
                                } : null}
                                onChange={handleInspectionOfficerChangeTo}
                                options={inspectionOfficers.sort((a, b) => a.fullname.localeCompare(b.fullname)).map((officer) => ({
                                    value: officer.id,
                                    label: formatFullName(officer.fullname),
                                    username: officer.username,
                                    poimsUserId: officer.id,

                                }))}
                                placeholder="Assigned To"
                                isSearchable
                                styles={customStyles}

                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown}
                                onMenuClose={toggleDropdown}
                                isDisabled={isReportGenerated}
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                    </div>
                    <div className="allocationReport-mainBlock">
                        <div className="allocationReport-group-cu-1">
                            <label htmlFor="startDate" className=" "><span className="asterisk">*</span>From Date</label>
                            <div className="allocationReport-setting-stock-repo">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="allocationReport-input-repo"
                                    value={startDate ? format(startDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowCalendar(true)}
                                    required
                                />
                                <div className="allocationReport-icon-test-stock-repo" onClick={() => setShowCalendar(true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showCalendar && (
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        dateFormat="DD-MM-YYYY"
                                        //  showMonthYearPicker 
                                        onClickOutside={() => setShowCalendar(false)}
                                        inline
                                        minDate={minStartDate} // From January 1st of current year
                                    //  maxDate={currentDate} // Today
                                    />
                                )}
                            </div>
                        </div>


                        <div className="allocationReport-group-cu-2">
                            <label htmlFor="startDate" className=" "><span className="asterisk">*</span>To Date</label>
                            <div className="allocationReport-setting-stock-repo">
                                <input
                                    type="text"
                                    id="startDate"
                                    className="allocationReport-input-repo"
                                    value={endDate ? format(endDate, 'dd-MM-yyyy') : ''}
                                    readOnly
                                    onClick={() => setShowEndCalendar(true)}
                                    required
                                    disabled={!startDate}
                                />
                                <div className="allocationReport-icon-test-stock-repo" onClick={handleEndDateIconClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                        <path d="M7 10l5 5 5-5z" />
                                    </svg>
                                </div>
                                {showEndCalendar && (
                                    <DatePicker
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        dateFormat="DD-MM-yyyy"
                                        onClickOutside={() => setShowEndCalendar(false)}
                                        minDate={startDate}
                                        // maxDate={currentDate}
                                        inline
                                    />
                                )}
                            </div>
                        </div>
                        <div className="allocationReport-group-cu-testing-2-stock-repo-btn">
                            <div className="allocationReport-group-cu-testing-2-stock-repo">
                                <button className="allocationReport-btn-test-stock-repo" onClick={handleClear}
                                    disabled={!((districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))}
                                >CLEAR
                                </button>
                            </div>
                            <div className="allocationReport-group-cu-testing-2-stock-repo">
                                <button
                                    className="allocationReport-btn-test-stock-repo"
                                    onClick={handleGenerateReport}
                                    disabled={isReportGenerated || !((districtUid && startDate && endDate) || (districtUid === null && startDate && endDate))}
                                >
                                    GENERATE REPORT
                                </button>

                            </div>
                            {startDate && endDate && showDownloadButton && showTable && dataAvailable && (
                                <div className="allocationReport-group-cu-testing-stock-repo">
                                    <button onClick={generatePDF} className="allocationReport-btn-test-stock-repo-pd">
                                        DOWNLOAD PDF
                                    </button>
                                    <button onClick={generateExcel} className="allocationReport-btn-test-stock-repo-px">
                                        DOWNLOAD XLSX
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="allocationReport-main-repo">
                {/* Display District Table */}

                {/* Conditional rendering to prevent serial number in the total row */}
                {!selectedDistrict && !selectedSubdivision && !selectedBlock && (
                    <table className="allocationReport-table-repo">
                        <thead>
                            <tr>
                                <th>S. No</th> {/* Added S. No column header */}
                                {columns.map((column) => (
                                    <th key={column.Header}>{column.Header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="allocationReport-tbody">
                            {isLoading ? (
                                <tr>
                                    <td colSpan={columns.length + 1} style={{ textAlign: 'center' }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) : data.length > 0 ? (
                                data.map((row, index) => (
                                    <tr
                                        key={index}
                                        onClick={() => {
                                            // Skip click event if it's the total row
                                            if (index === data.length - 1) return;

                                            if (blockUid) {
                                                handleBlockClick(row); // Trigger Panchayat click if block data is selected
                                            } else if (subDivisionUid) {
                                                handleSubDivisionClick(row); // Trigger Block click otherwise
                                            } else if (districtUid) {
                                                handleDistrictClick(row);
                                            } else if (panchayatUid) {
                                                handlePanchayatClick(row);
                                            } else {
                                                handleDistrictClick(row); // Pass the entire row object
                                            }
                                        }}
                                        className={index === data.length - 1 ? 'total-row' : ''} // Total row styling
                                    >
                                        {/* Serial number (S. No) */}
                                        <td>{index === data.length - 1 ? '' : index + 1}</td> {/* Skip serial number in total row */}

                                        {columns.map((column) => (
                                            <td key={column.accessor}>
                                                {/* Render column data, fall back to '-' if value is empty */}
                                                {column.accessor === 'sno' ? row.sno : row[column.accessor] || ' '}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={columns.length + 1} style={{ textAlign: 'center', color: 'red' }}>
                                        No Data Available
                                    </td>
                                </tr>
                            )}


                        </tbody>
                    </table>
                )}



                {/* Display Subdivision Table */}
                {selectedDistrict && !selectedSubdivision && !selectedBlock && (
                    <div className="subdivision-table">
                        <button onClick={handleGoBack} className="back-button">
                            Back
                        </button>
                        <h3>{selectedDistrict.districtName} - Subdivisions</h3>
                        <table className="allocationReport-table-repo">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Sub-Division</th>
                                    <th>Total No. of FPS</th>
                                    <th>No. of FPS Allocated</th>
                                    <th>% Allocation</th>
                                </tr>
                            </thead>
                            <tbody className="allocationReport-tbody">
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={5} style={{ textAlign: 'center' }}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : subdivisionData.length > 0 ? (
                                    subdivisionData.map((subdivision, index) => (
                                        <tr key={index} onClick={() => handleSubDivisionClick(subdivision)}>
                                            <td>{index + 1}</td>
                                            <td>{capitalizeFirstLetter(subdivision.subDivisionName)}</td>
                                            <td>{subdivision.totalFps}</td> {/* Assuming you have totalFPS for the subdivision */}
                                            <td>{parseInt(subdivision.fpsCount) || '0'}</td>
                                            <td>{((subdivision.fpsCount / subdivision.totalFps) * 100).toFixed(2)}%</td> {/* Example for percentage calculation {((subdivision.fpsCount / 'N/A') * 100).toFixed(2)}% */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5} style={{ textAlign: 'center', color: 'red' }}>
                                            No Data Available
                                        </td>
                                    </tr>
                                )}

                                {/* Total Row */}
                                {subdivisionData.length > 0 && (
                                    <tr className="total-row">
                                        <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            Total FPS Count
                                        </td>
                                        <td style={{ fontWeight: 'bold' }}>
                                            {subdivisionData.reduce((total, subdivision) => total + (parseInt(subdivision.totalFps) || 0), 0)}

                                        </td>
                                        <td style={{ fontWeight: 'bold' }}>
                                            {subdivisionData.reduce((total, subdivision) => total + (parseInt(subdivision.fpsCount) || 0), 0)}

                                        </td>
                                        <td style={{ fontWeight: 'bold' }}>
                                            {((
                                                (subdivisionData.reduce((total, subdivision) => total + (parseInt(subdivision.fpsCount) || 0), 0) || 0) /
                                                (subdivisionData.reduce((total, subdivision) => total + (parseInt(subdivision.totalFps) || 0), 0) || 1)
                                            ) * 100).toFixed(2)
                                            }%
                                        </td>

                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}


                {/* Display Block Table */}
                {selectedSubdivision && !selectedBlock && (
                    <div className="block-table">
                        <button onClick={handleGoBack} className="back-button">
                            Back
                        </button>
                        <h3>{capitalizeFirstLetter(selectedDistrict?.districtName || getDistrictName(districtUid))} - {capitalizeFirstLetter(selectedSubdivision?.subDivisionName || getSubDivisionName(subDivisionUid))} - Blocks</h3>
                        <table className="allocationReport-table-repo">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Block</th>
                                    <th>Total No. of FPS</th>
                                    <th>No. of FPS Allocated</th>
                                    <th>% Allocation</th>
                                </tr>
                            </thead>
                            <tbody className="allocationReport-tbody">
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: 'center' }}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : blockData.length > 0 ? (
                                    blockData.map((block, index) => (
                                        <tr key={index} onClick={() => handleBlockClick(block)}>
                                            <td>{index + 1}</td>
                                            <td>{capitalizeFirstLetter(block.blockName)}</td>
                                            <td>{block.totalFps}</td>
                                            <td>{block.fpsCount || '0'}</td>
                                            <td>{((block.fpsCount / block.totalFps) * 100).toFixed(2)}%</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: 'center', color: 'red' }}>
                                            No Data Available
                                        </td>
                                    </tr>
                                )}
                                {blockData.length > 0 && (
                                    <tr className="total-row">
                                        <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            Total FPS Count
                                        </td>

                                        <td style={{ fontWeight: 'bold' }}>
                                            {blockData.reduce((total, block) => total + parseInt(block.totalFps || 0), 0)}
                                        </td>
                                        <td style={{ fontWeight: 'bold' }}>
                                            {blockData.reduce((total, block) => total + parseInt(block.fpsCount || 0), 0)}
                                        </td>
                                        <td style={{ fontWeight: 'bold' }}>
                                            {((
                                                (blockData.reduce((total, block) => total + (parseInt(block.fpsCount) || 0), 0) || 0) /
                                                (blockData.reduce((total, block) => total + (parseInt(block.totalFps) || 0), 0) || 1)
                                            ) * 100).toFixed(2)
                                            }%
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Display Panchayat Table */}
                {selectedBlock && !selectedPanchayat && (
                    <div className="panchayat-table">
                        <button onClick={handleGoBack} className="back-button">
                            Back
                        </button>
                        <h3>{capitalizeFirstLetter(selectedDistrict?.districtName || getDistrictName(districtUid))}- {capitalizeFirstLetter(selectedSubdivision?.subDivisionName || getSubDivisionName(subDivisionUid))}- {capitalizeFirstLetter(selectedBlock?.blockName || getBlockName(blockUid))} - Panchayats</h3>
                        <table className="allocationReport-table-repo">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Panchayat</th>
                                    <th>Total No. of FPS</th>
                                    <th>No. of FPS Allocated</th>
                                    <th>% Allocation</th>
                                </tr>
                            </thead>
                            <tbody className="allocationReport-tbody">
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: 'center' }}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : panchayatData.length > 0 ? (
                                    panchayatData.map((panchayat, index) => (
                                        <tr key={index} onClick={() => handlePanchayatClick(panchayat)}>
                                            <td>{index + 1}</td>
                                            <td>{capitalizeFirstLetter(panchayat.panchayatName)}</td>
                                            <td>{panchayat.totalFps}</td>
                                            <td>{parseInt(panchayat.fpsCount || 0)}</td>
                                            <td>{((panchayat.fpsCount / panchayat.totalFps) * 100).toFixed(2)}%</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: 'center', color: 'red' }}>
                                            No Data Available
                                        </td>
                                    </tr>
                                )}
                                {panchayatData.length > 0 && (
                                    <tr className="total-row">
                                        <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            Total FPS Count
                                        </td>
                                        <td style={{ fontWeight: 'bold' }}>
                                            {panchayatData.reduce((total, panchayat) => total + parseInt(panchayat.totalFps || 0), 0)}
                                        </td>
                                        <td style={{ fontWeight: 'bold' }}>
                                            {panchayatData.reduce((total, panchayat) => total + parseInt(panchayat.fpsCount || 0), 0)}
                                        </td>
                                        <td style={{ fontWeight: 'bold' }}>
                                            {((
                                                (panchayatData.reduce((total, panchayat) => total + (parseInt(panchayat.fpsCount) || 0), 0) || 0) /
                                                (panchayatData.reduce((total, panchayat) => total + (parseInt(panchayat.totalFps) || 0), 0) || 1)
                                            ) * 100).toFixed(2)
                                            }%
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Show the Assigned Data for Panchayat table ONLY after successful click and data fetch */}
                {selectedPanchayat && (
                    <div className="assigned-data-table">
                        <button onClick={handleGoBack} className="back-button">
                            Back
                        </button>
                        <h3>
                            {capitalizeFirstLetter(selectedDistrict?.districtName || getDistrictName(districtUid))} - {capitalizeFirstLetter(selectedSubdivision?.subDivisionName || getSubDivisionName(subDivisionUid))} - {capitalizeFirstLetter(selectedBlock?.blockName || getBlockName(blockUid))} - {capitalizeFirstLetter(selectedPanchayat?.panchayatName)}
                        </h3>
                        <table className="allocationReport-table-repo">
                            <thead>
                                <tr>
                                    <th>Assigned By</th>
                                    <th>Assigned To</th>
                                    <th>Date of Inspection</th>
                                    {/* <th>Total No. of FPS</th> */}
                                    <th>FPS ID</th>
                                    {/* <th>% Allocation</th> */}
                                </tr>
                            </thead>
                            <tbody className="allocationReport-tbody">
                                {afterpanchayatData.length > 0 ? (
                                    afterpanchayatData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{formatFullName(item.assignedBy)}</td>
                                            <td>{formatFullName(item.assignedTo)}</td>
                                            <td>{formatDateTable(item.dateOfInspection)}</td>
                                            {/* <td>{item.totalFps}</td> */}
                                            <td>{parseInt(item.fpsId)}</td>
                                            {/* <td>{((item.fpsCount / item.totalFps) * 100).toFixed(2)}%</td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6} style={{ textAlign: 'center', color: 'red' }}>
                                            No data available for the selected Panchayat. Please check again later.
                                        </td>
                                    </tr>
                                )}

                            </tbody>
                        </table>
                    </div>
                )}

            </div>




        </div>
    );
};

export default InspectionAllocationReport;